function identifyCode(value) {
  const identifyCodeRegexp = /^[a-zA-Z][0-9]{9}$/;
  return identifyCodeRegexp.test(value);
}

function zeroOneTwo(value) {
  const classRegExp = /^[0-2]{1}$/;
  return classRegExp.test(value);
}

function tel(value) {
  const classRegExp = /^[0-9]{9,11}$/;
  return classRegExp.test(value);
}

function mobile(value) {
  const mobileRegExp = /^09[0-9]{8}$/;
  return mobileRegExp.test(value);
}

function numberOnly(value) {
  const numberOnlyRegExp = /\d/g;
  return numberOnlyRegExp.test(value);
}

function licenseNumber(value) {
  const licenseNumberRegExp = /^[a-zA-Z0-9]{2,4}-{0,1}[a-zA-Z0-9]{2,4}$/;
  return licenseNumberRegExp.test(value);
}

function dateTime(value) {
  const dateTimeRegExp = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;
  return dateTimeRegExp.test(value);
}

function verification(value) {
  const verificationRegExp = /^[Y|N]{1}$/;
  return verificationRegExp.test(value);
}

export default {
  identifyCode,
  zeroOneTwo,
  tel,
  mobile,
  numberOnly,
  licenseNumber,
  dateTime,
  verification
};
